import { actionTypes, RENAME_GATEWAY } from './constants';
import { actionTypes as connectedAssetActionTypes } from './ConnectedAssets/ConnectedAssetsDrives/constants';
import { VALIDATE_GATEWAY_ASSET, CLEAR_VALIDATE_GATEWAY_ASSET_STATE } from './ConnectedAssets/ConnectedAssetsDrives/MoveToAnotherGateway/constants';
import { apiCallStatus } from 'helpers/constants';
import { CLEAR_VALIDATE_SWITCH_GATEWAY_ASSET_STATE, VALIDATE_SWITCH_GATEWAY_ASSET, GET_GATEWAY_ASSETS_LIST, RESET_SWITCH_GATEWAY_VALIDATION_RESULT, MOVE_TO_ANOTHER_GATEWAY, SWITCH_TO_ANOTHER_GATEWAY } from './ConnectedAssets/ConnectedAssetsDrives/SwitchToAnotherGateway/constants';
const initialState = {
    gatewayInfo: {},
    error: null,
    loadingStatus: null,
};

const initialStateConnectedAssets = {
    gatewayConnectedAssets: {},
    error: null,
    loadingStatus: null
};

const initialStateUserCapabilities = {
    data: null,
    error: null,
    loadingStatus: null
};

const initialSwitchValidateState = {
    loadingStatus: null,
    isMoveValid: null,
    validationMessage: null,
    error: null,
    assetList: [],
    switchGatewayId: null,
    assetListLoadingStatus: null,
    isSwitchEgwToAnotherGateway: true
};
const initialValidateState = {
    loadingStatus: null,
    isMoveValid: null,
    error: null,
};

const initialInstallationReportState = {
    loadingStatus: null,
    data: null,
    error: null
};

const initialDownloadDiagnosticReportState = {
    loadingStatus: null,
    reportData: null,
    error: null
};

const initialConnectionHistoryGatewayState = {
    gatewayConnectionHistory: {},
    error: null,
    loadingStatus: null
};

const initialConnectionHistoryAssetState = {
    assetConnectionHistory: {},
    rssiHistoryData: [],
    rssiHistoryLoadingStatus: null,
    rssiHistoryError: null,
    error: null,
    loadingStatus: null
};

const initialConnectedHistoryState = {
    data: null,
    loadingStatus: null,
    error: null,
    lastQueryParams: null,
};

// eslint-disable-next-line import/no-unused-modules
export function reducer(state = initialState, action) {
    switch (action.type) {
        case actionTypes.CLEAR_STORE: {
            return initialState;
        }
        case actionTypes.GET_GATEWAY_INFO_SETTINGS:
            if (action.loadingStatus === apiCallStatus.LOADING) {
                return {
                    ...state,
                    loadingStatus: apiCallStatus.LOADING,
                    error: null
                };
            } else if (action.loadingStatus === apiCallStatus.SUCCESS) {
                return {
                    ...state,
                    loadingStatus: apiCallStatus.SUCCESS,
                    gatewayInfo: action.data,
                    error: null
                };
            } else if (action.loadingStatus === apiCallStatus.ERROR) {
                return {
                    ...state,
                    loadingStatus: apiCallStatus.ERROR,
                    gatewayInfo: {},
                    error: action.error
                };
            }
            break;
        case RENAME_GATEWAY:
            if (action.loadingStatus === apiCallStatus.LOADING) {
                return {
                    ...state,
                    loadingStatus: apiCallStatus.LOADING,
                    error: null
                };
            } else if (action.loadingStatus === apiCallStatus.SUCCESS) {
                return {
                    ...state,
                    gatewayInformation: {
                        ...state.gatewayInformation,
                        gatewayInfo: {
                            ...state.gatewayInformation?.gatewayInfo,
                            gatewayName: action?.data?.name
                        }
                    }
                };
            } else if (action.loadingStatus === apiCallStatus.ERROR) {
                return {
                    ...state,
                    loadingStatus: apiCallStatus.ERROR,
                    gatewayInfo: {},
                    error: action.error
                };
            }
            break;
        default:
            return state;
    }
}

// eslint-disable-next-line import/no-unused-modules
export function connectedAssetReducer(state = initialStateConnectedAssets, action) {
    switch (action.type) {
        case actionTypes.CLEAR_STORE: {
            return initialStateConnectedAssets;
        }
        case actionTypes.GET_GATEWAY_CONNECTED_ASSETS_SETTINGS:
            if (action.loadingStatus === apiCallStatus.LOADING) {
                return {
                    ...state,
                    loadingStatus: apiCallStatus.LOADING,
                    error: null
                };
            } else if (action.loadingStatus === apiCallStatus.SUCCESS) {
                return {
                    ...state,
                    loadingStatus: apiCallStatus.SUCCESS,
                    gatewayConnectedAssets: action.data,
                    error: null
                };
            } else if (action.loadingStatus === apiCallStatus.ERROR) {
                return {
                    ...state,
                    loadingStatus: apiCallStatus.ERROR,
                    gatewayConnectedAssets: {},
                    error: action.error
                };
            }
            break;
        default:
            return state;
    }
}

// eslint-disable-next-line import/no-unused-modules
export function userCapabilitiesReducer(state = initialStateUserCapabilities, action) {
    switch (action.type) {
        case actionTypes.CLEAR_GATEWAY_CAPABILITIES: {
            return initialStateUserCapabilities;
        }
        case actionTypes.GET_USER_CAPABILITY_SETTINGS:
            if (action.loadingStatus === apiCallStatus.LOADING) {
                return {
                    ...state,
                    loadingStatus: apiCallStatus.LOADING,
                    error: null
                };
            } else if (action.loadingStatus === apiCallStatus.SUCCESS) {
                return {
                    ...state,
                    loadingStatus: apiCallStatus.SUCCESS,
                    data: action.data,
                    error: null
                };
            } else if (action.loadingStatus === apiCallStatus.ERROR) {
                return {
                    ...state,
                    loadingStatus: apiCallStatus.ERROR,
                    data: null,
                    error: action.error
                };
            }
            break;
        default:
            return state;
    }
}
// eslint-disable-next-line import/no-unused-modules
export function validateGatewayAssetReducer(state = initialValidateState, action) {
    switch (action.type) {
        case CLEAR_VALIDATE_GATEWAY_ASSET_STATE: {
            return initialValidateState;
        }
        case VALIDATE_GATEWAY_ASSET:
            if (action.loadingStatus === apiCallStatus.LOADING) {
                return {
                    ...state,
                    loadingStatus: action.loadingStatus,
                    error: null
                };
            } else if (action.loadingStatus === apiCallStatus.SUCCESS) {
                return {
                    ...state,
                    loadingStatus: action.loadingStatus,
                    isMoveValid: action.data.isMoveValid,
                    error: null
                };
            } else if (action.loadingStatus === apiCallStatus.ERROR) {
                return {
                    ...state,
                    loadingStatus: apiCallStatus.ERROR,
                    isMoveValid: null,
                    error: action.error
                };
            }
            break;
        default:
            return state;
    }
}

export function downloadDiagnosticReportReducer(state = initialDownloadDiagnosticReportState, action) {
    switch (action.type) {
        case actionTypes.DOWNLOAD_DIAGNOSTIC_REPORT_SETTINGS:
            if (action.loadingStatus === apiCallStatus.LOADING) {
                return {
                    ...state,
                    loadingStatus: apiCallStatus.LOADING,
                    error: null
                };
            } else if (action.loadingStatus === apiCallStatus.SUCCESS) {
                return {
                    ...state,
                    loadingStatus: apiCallStatus.SUCCESS,
                    reportData: action.data,
                    error: null
                };
            } else if (action.loadingStatus === apiCallStatus.ERROR) {
                return {
                    ...state,
                    loadingStatus: apiCallStatus.ERROR,
                    reportData: null,
                    error: action.error
                };
            }
            return state;
        case actionTypes.CLEAR_DOWNLOAD_DIAGNOSTIC_REPORT: {
            return initialDownloadDiagnosticReportState;
        }
        default:
            return state;
    }
}

// eslint-disable-next-line import/no-unused-modules
export function validateSwitchGatewayAssetReducer(state = initialSwitchValidateState, action) {
    switch (action.type) {
        case GET_GATEWAY_ASSETS_LIST:
            if (action.loadingStatus === apiCallStatus.LOADING) {
                return {
                    ...state,
                    assetListLoadingStatus: apiCallStatus.LOADING,
                    error: null
                };
            } else if (action.loadingStatus === apiCallStatus.SUCCESS) {
                return {
                    ...state,
                    assetListLoadingStatus: apiCallStatus.SUCCESS,
                    assetList: action.data,
                    switchGatewayId: action?.data?.gatewayId || null,
                    error: null
                };
            } else if (action.loadingStatus === apiCallStatus.ERROR) {
                return {
                    ...state,
                    assetListLoadingStatus: apiCallStatus.ERROR,
                    assetList: [],
                    switchGatewayId: null,
                    error: action.error
                };
            }
            break;
        case CLEAR_VALIDATE_SWITCH_GATEWAY_ASSET_STATE: {
            return initialSwitchValidateState;
        }
        case RESET_SWITCH_GATEWAY_VALIDATION_RESULT: {
            return {
                ...state,
                isMoveValid: null,
                validationMessage: null,
                error: null,
                loadingStatus: null,
            };
        }
        case VALIDATE_SWITCH_GATEWAY_ASSET:
            if (action?.loadingStatus === apiCallStatus.LOADING) {
                return {
                    ...state,
                    loadingStatus: action?.loadingStatus,
                    error: null
                };
            } else if (action?.loadingStatus === apiCallStatus.SUCCESS) {
                return {
                    ...state,
                    loadingStatus: action?.loadingStatus,
                    isMoveValid: action?.data?.isMoveValid,
                    validationMessage: action?.data?.message,
                    error: null
                };
            } else if (action?.loadingStatus === apiCallStatus.ERROR) {
                return {
                    ...state,
                    loadingStatus: apiCallStatus.ERROR,
                    isMoveValid: null,
                    validationMessage: null,
                    error: action?.error
                };
            }
            break;
        case MOVE_TO_ANOTHER_GATEWAY:
            if (action?.loadingStatus === apiCallStatus.LOADING) {
                return {
                    ...state,
                    loadingStatus: action?.loadingStatus,
                    error: null
                };
            } else if (action.loadingStatus === apiCallStatus.SUCCESS) {
                return {
                    ...state,
                    loadingStatus: apiCallStatus.SUCCESS,
                    isMoveValid: action?.data?.isMoveValid,
                    validationMessage: action?.data?.message,
                    error: null
                };
            } else if (action.loadingStatus === apiCallStatus.ERROR) {
                return {
                    ...state,
                    loadingStatus: apiCallStatus.ERROR,
                    isMoveValid: null,
                    validationMessage: null,
                    error: action?.error
                };
            }
            break;
        case SWITCH_TO_ANOTHER_GATEWAY:
            if (action?.loadingStatus === apiCallStatus.LOADING) {
                return {
                    ...state,
                    loadingStatus: apiCallStatus.LOADING,
                    error: null
                };
            } else if (action?.loadingStatus === apiCallStatus.SUCCESS) {
                return {
                    ...state,
                    loadingStatus: apiCallStatus.SUCCESS,
                    isMoveValid: action?.data?.isMoveValid,
                    validationMessage: action?.data?.message,
                    error: null
                };
            } else if (action?.loadingStatus === apiCallStatus.ERROR) {
                return {
                    ...state,
                    loadingStatus: apiCallStatus.ERROR,
                    isMoveValid: null,
                    validationMessage: null,
                    error: action?.error
                };
            }
            break;
        default:
            return state;
    }
}

export function installationReportReducer(state = initialInstallationReportState, action) {
    switch (action.type) {
        case actionTypes.DOWNLOAD_INSTALLATION_REPORT_SETTINGS:
            if (action.loadingStatus === apiCallStatus.LOADING) {
                return {
                    ...state,
                    loadingStatus: apiCallStatus.LOADING,
                    error: null
                };
            }
            else if (action.loadingStatus === apiCallStatus.SUCCESS) {
                return {
                    ...state,
                    loadingStatus: apiCallStatus.SUCCESS,
                    data: action.data,
                    error: null
                };
            }
            else if (action.loadingStatus === apiCallStatus.ERROR) {
                return {
                    ...state,
                    loadingStatus: apiCallStatus.ERROR,
                    data: null,
                    error: action.error
                };
            }
            break;
        case actionTypes.CLEAR_INSTALLATION_REPORT: {
            return initialInstallationReportState;
        }
        default:
            return state;
    }
}

export function connectionHistoryGatewayReducer(state = initialConnectionHistoryGatewayState, action) {
    switch (action.type) {
        case actionTypes.GET_CONNECTION_HISTORY_GATEWAY_SETTINGS:
            if (action.loadingStatus === apiCallStatus.LOADING) {
                return {
                    ...state,
                    loadingStatus: apiCallStatus.LOADING,
                    error: null
                };
            } else if (action.loadingStatus === apiCallStatus.SUCCESS) {
                return {
                    ...state,
                    loadingStatus: apiCallStatus.SUCCESS,
                    gatewayConnectionHistory: action.data,
                    error: null
                };
            } else if (action.loadingStatus === apiCallStatus.ERROR) {
                return {
                    ...state,
                    loadingStatus: apiCallStatus.ERROR,
                    gatewayConnectionHistory: null,
                    error: action.error
                };
            }
            break;
        case actionTypes.CLEAR_CONNECTION_HISTORY: {
            return initialConnectionHistoryGatewayState;
        }
        default:
            return state;
    }
}

export function connectionHistoryAssetReducer(state = initialConnectionHistoryAssetState, action) {
    switch (action.type) {
        case actionTypes.GET_CONNECTION_HISTORY_ASSET_SETTINGS:
            if (action.loadingStatus === apiCallStatus.LOADING) {
                return {
                    ...state,
                    loadingStatus: apiCallStatus.LOADING,
                    error: null
                };
            } else if (action.loadingStatus === apiCallStatus.SUCCESS) {
                return {
                    ...state,
                    loadingStatus: apiCallStatus.SUCCESS,
                    assetConnectionHistory: action.data,
                    error: null
                };
            } else if (action.loadingStatus === apiCallStatus.ERROR) {
                return {
                    ...state,
                    loadingStatus: apiCallStatus.ERROR,
                    assetConnectionHistory: null,
                    error: action.error
                };
            }
            break;
        case connectedAssetActionTypes.GET_RSSI_HISTORY_SETTINGS:
            if (action.loadingStatus === apiCallStatus.LOADING) {
                return {
                    ...state,
                    rssiHistoryLoadingStatus: apiCallStatus.LOADING,
                    rssiHistoryError: null
                };
            } else if (action.loadingStatus === apiCallStatus.SUCCESS) {
                return {
                    ...state,
                    rssiHistoryLoadingStatus: apiCallStatus.SUCCESS,
                    rssiHistoryData: action.data || [],
                    rssiHistoryError: null
                };
            } else if (action.loadingStatus === apiCallStatus.ERROR) {
                return {
                    ...state,
                    rssiHistoryLoadingStatus: apiCallStatus.ERROR,
                    rssiHistoryData: [],
                    rssiHistoryError: action.error
                };
            }
            break;
        case connectedAssetActionTypes.CLEAR_RSSI_HISTORY:
            return {
                ...state,
                rssiHistoryData: [],
                rssiHistoryLoadingStatus: null,
                rssiHistoryError: null
            };
        case actionTypes.CLEAR_CONNECTION_HISTORY: {
            return initialConnectionHistoryAssetState;
        }
        default:
            return state;
    }
}

export function connectedHistoryReducer(state = initialConnectedHistoryState, action) {
    switch (action.type) {
        case actionTypes.GET_CONNECTED_HISTORY:
            if (!action.payload?.nextCursor && !action.payload?.prevCursor) {
                return { ...state, lastQueryParams: action.payload };
            }
            return state;
        case actionTypes.GET_CONNECTED_HISTORY_SETTINGS:
            if (action.loadingStatus === apiCallStatus.LOADING) {
                return { ...state, loadingStatus: apiCallStatus.LOADING, error: null };
            } else if (action.loadingStatus === apiCallStatus.SUCCESS) {
                return { ...state, loadingStatus: apiCallStatus.SUCCESS, data: action.data, error: null };
            } else if (action.loadingStatus === apiCallStatus.ERROR) {
                return { ...state, loadingStatus: apiCallStatus.ERROR, data: null, error: action.error };
            }
            break;
        case actionTypes.CLEAR_CONNECTED_HISTORY:
            return initialConnectedHistoryState;
        default:
            return state;
    }
}
